import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getTokenUser } from '../_services/token.service'

export const RoleBasedRouting = ({ roles }) => {
  return getTokenUser(roles) ? <Outlet /> : <Navigate to="/login" />
}
